import React from "react"

import { Tag } from "antd"
import { PurchaseOrderDeliveryStatusEnum } from "@finway-group/shared/lib/models"
import { useTranslation } from "react-i18next"

const statusClasses = {
    [PurchaseOrderDeliveryStatusEnum.NOT_DELIVERED]: "ant-tag-red",
    [PurchaseOrderDeliveryStatusEnum.PARTIALLY_DELIVERED]: "ant-tag-yellow",
    [PurchaseOrderDeliveryStatusEnum.FULLY_DELIVERED]: "ant-tag-success",
}

interface PurchaseOrderDeliveryStatusTagProps {
    status: PurchaseOrderDeliveryStatusEnum
    short?: boolean
    className?: string
}

export const PurchaseOrderDeliveryStatusTag = ({ status, short = false, className = "" }: PurchaseOrderDeliveryStatusTagProps) => {
    const { t } = useTranslation()

    const label = short ? t(`purchaseOrders:deliveryStatus.short.${status}`) : t(`purchaseOrders:deliveryStatus.full.${status}`)

    return <Tag className={`${statusClasses[status]} ${className}`}>{label}</Tag>
}
